var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCheckGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M19.7071 3.64148L10.3418 13.0587L7.50005 10.2106L16.8793 0.796561C16.9715 0.703673 17.081 0.629845 17.2016 0.579296C17.3223 0.528748 17.4517 0.502468 17.5825 0.501961C17.7133 0.501453 17.843 0.526726 17.964 0.576337C18.085 0.625947 18.1951 0.698922 18.2879 0.791092L18.2934 0.796561L19.7071 2.21883C19.8947 2.40802 20 2.66369 20 2.93015C20 3.19662 19.8947 3.45229 19.7071 3.64148V3.64148Z",
    fill: "#23BD86"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3387 13.0622L8.20711 15.2055C8.02103 15.393 7.7681 15.499 7.50394 15.5C7.23979 15.501 6.98604 15.3971 6.79851 15.211L6.79305 15.2055L0.293045 8.66805C0.105338 8.47897 0 8.22335 0 7.95692C0 7.69049 0.105338 7.43486 0.293045 7.24578L1.70711 5.82352C1.89288 5.63648 2.14524 5.53075 2.40886 5.5295C2.67248 5.52826 2.92583 5.6316 3.11336 5.81688L3.11961 5.82352L10.3387 13.0622Z",
    fill: "#23BD86"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckGreen);
export default __webpack_public_path__ + "static/media/IconCheckGreen.935729cc9d27721c9f003faefcbb404c.svg";
export { ForwardRef as ReactComponent };